import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';

const DefaultSequenceCharCodeRangeArray = ['az', 'AZ', '09'].map(
  (sequenceChars) => [sequenceChars.charCodeAt(0), sequenceChars.charCodeAt(1)] as [number, number]
);

export function Sequence(
  sequenceLength: number,
  sequenceCharCodeRangeArray: [number, number][] = DefaultSequenceCharCodeRangeArray
) {
  if (sequenceLength < 1) {
    throw new Error('sequenceLength should be at least 2');
  }

  return (control: AbstractControl) => {
    const value = control.value ? String(control.value) : '';

    let repeatedCharsCount = 1;
    for (let charAt = 1; charAt < value.length; charAt++) {
      const sequence1 = getSequenceCharCodeRange(value, charAt - 1, sequenceCharCodeRangeArray);
      if (!sequence1) {
        repeatedCharsCount = 1;
        continue;
      }
      const sequence2 = getSequenceCharCodeRange(value, charAt, sequenceCharCodeRangeArray);
      if (!sequence2 || (sequence1[0] !== sequence2[0] && sequence1[1] !== sequence2[1])) {
        repeatedCharsCount = 1;
        charAt++;
        continue;
      }

      if (value.charCodeAt(charAt - 1) === value.charCodeAt(charAt) - 1) {
        repeatedCharsCount++;
      } else {
        repeatedCharsCount = 1;
      }

      if (repeatedCharsCount === sequenceLength) {
        return {sequence: true};
      }
    }

    return null;
  };
}

function getSequenceCharCodeRange(value: string, charAt: number, sequenceCharCodeRangeArray: [number, number][]) {
  return sequenceCharCodeRangeArray.find((sequenceCharCodeRange) => {
    const charCode = value.charCodeAt(charAt);
    return isBetweenRange(charCode, sequenceCharCodeRange);
  });
}

function isBetweenRange(num, [rangeStart, rangeEnd]: [number, number]) {
  return rangeStart <= num && num <= rangeEnd;
}

@Directive({
  selector: '[sequence]',
  providers: [{provide: NG_VALIDATORS, useExisting: SequenceDirective, multi: true}],
})
export class SequenceDirective implements Validator {
  private sequenceLength: number;

  @Input()
  set sequence(value: number) {
    this.validate = Sequence((this.sequenceLength = value));
  }
  get sequence() {
    return this.sequenceLength;
  }

  validate(control: AbstractControl) {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/sequence.validator.ts